var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',_vm._b({staticClass:"badge",attrs:{"active":true,"flat":""}},'vs-button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Badge")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }